import { useEffect, VFC } from 'react';
import { useSelector } from 'react-redux';

import { useConfig } from '../../config';
import { fromAuth, useAppDispatch } from '../../store';

const Logout: VFC = () => {
  const { config } = useConfig();
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(fromAuth.selectIsAuthenticated);

  useEffect(() => {
    dispatch(fromAuth.doLogout({
      redirectUrl: `${window.location.origin}/logout`,
    }));
  }, [dispatch]);

  if (config && !isAuthenticated) {
    window.location.replace(`${window.location.origin}/login`);
  }

  return null;
};

export default Logout;
